import { type MCPServerInfo } from '../../types';

const Microsoft365Server: MCPServerInfo = {
  serverId: 'MICROSOFT365',
  name: 'Microsoft 365',
  slug: 'microsoft365',
  description: 'M365 MCP Server',
  source: {
    sourceType: 'REPOSITORY',
    type: 'NATOMA',
    repositoryUrl: 'mcp/m365-internal:latest',
    commitSha: 'latest',
    packageType: 'pip',
    packageName: ''
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['tenantId', 'clientId', 'clientSecret'],
    properties: {
      tenantId: {
        type: 'string',
        description: 'tenant ID',
        sensitive: false
      },
      clientId: {
        type: 'string',
        description: 'client ID',
        sensitive: false
      },
      clientSecret: {
        type: 'string',
        description: 'client Secret',
        sensitive: true
      }
    }
  }
};

export default Microsoft365Server;
